import React, { ComponentType } from 'react';
import { Container, Row, Column, Justify } from '@uds/grid';
import { useBreakpoints } from '@ux/responsive';
import { CTA } from 'core/ribbons/cta';
import { ImagesWithAspectRatios } from 'core/ribbons/primitives';
import { ImageAspectRatio } from 'domain/constants/imageAspectRatio';
import { Alignment } from 'domain/constants/alignment';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';
import { ShortcodeProps } from 'presentation/components/Shortcode';
import { bootstrapResponsiveColumns } from 'presentation/utils/responsiveColumns';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';
import Ribbon from 'components/ribbons/Ribbon';

import Pillar from './Pillar';
import { classNames } from './Pillars.stylesheet';

type PillarProps = {
  illustration?: string;
  imagesWithAspectRatios?: ImagesWithAspectRatios;
  imageUrl?: string;
  preserveDimension?: string;
  imageAspectRatio?: ImageAspectRatio;
  title?: ShortcodeProps;
  body?: ShortcodeProps;
  ctas?: Array<CTA>;
};
interface OuterProps extends RibbonProps {
  pillars: Array<PillarProps>;
}

export const PurePillars = ({
  id,
  hBaseline = 3,
  layout,
  pillars,
  colorway,
  loading,
  name,
  id: ribbonId,
}: OuterProps) => {
  const alignment = findResponsiveItem(useBreakpoints(), [
    layout?.alignmentMobile ?? Alignment.STARTING,
    layout?.alignmentTablet ?? Alignment.STARTING,
    layout?.alignment ?? Alignment.STARTING,
  ]);
  const justify = alignment === Alignment.CENTER ? Justify.CENTER : Justify.FLEX_START;

  // default
  const layoutColumns = layout.columns ?? null;
  // @ts-ignore: error after upgrading to ux-configs
  const columns = bootstrapResponsiveColumns([1, 2, 4], layoutColumns);

  return (
    <Ribbon id={id} colorway={colorway} layout={layout} loading={loading} name={name} type={Type.PILLARS}>
      <Container>
        <div className={classNames.container}>
          <Row justify={justify}>
            {pillars.map((pillar, i) => (
              <Column
                // eslint-disable-next-line react/no-array-index-key -- No other identifier is available.
                key={i}
                xs={columns[0]}
                sm={columns[1]}
                lg={columns[2]}
              >
                <Pillar
                  hBaseline={hBaseline}
                  colorway={colorway}
                  alignment={alignment}
                  ribbonId={ribbonId}
                  {...pillar}
                />
              </Column>
            ))}
          </Row>
        </div>
      </Container>
    </Ribbon>
  );
};
PurePillars.displayName = 'Pillars';

export default visibilitySet(errorBoundary(PurePillars)) as ComponentType<OuterProps>;
